import React from "react";
import "./Milestone.css";
import { FaTrophy, FaChessKnight, FaSearch, FaChartBar, FaBolt, FaPlay, FaIndustry, FaSync, FaRobot } from "react-icons/fa";
import topImage from "../Assets/history (1).jpg";

const Milestone = () => {
  const milestones = [
    {
      year: "2009",
      title: "Achieved Breakeven",
      description: "Achieved breakeven in less than 12 months from the inception of the company.",
      icon: <FaPlay />,
      color: "#FACC15",
    },
    {
      year: "2011",
      title: "Remote Tower Solution",
      description: "End to end remote tower management solution for telecom sector.",
      icon: <FaChessKnight />,
      color: "#F97316",
    },
    {
      year: "2012",
      title: "Patent Application",
      description: "Applied for patents for wireless battery monitoring system.",
      icon: <FaBolt />,
      color: "#EF4444",
    },
    {
      year: "2015",
      title: "Power Sector Entry",
      description: "Diversified into power sector.",
      icon: <FaSearch />,
      color: "#3B82F6",
    },
    {
      year: "2017",
      title: "3GModem Launch",
      description: "Launched 3G Modem device, software, and mobile app for prepaid metering solution.",
      icon: <FaChartBar />,
      color: "#A855F7",
    },
    {
      year: "2019",
      title: "Rebranding to Vajra IOT",
      description: "Greenarkenersol becomes Vajra IOT.",
      icon: <FaSync />,
      color: "#1E3A8A",
    },
    {
      year: "2020",
      title: "Mining Sector Entry",
      description: "Entering Into Mining Section.",
      icon: <FaIndustry />,
      color: "#E74C3C",
    },
    {
      year: "2024",
      title: "Substation Automation",
      description: "Entering Into Substation Automation.",
      icon: <FaTrophy />,
      color: "#2ECC71",
    },
    {
      year: "2025",
      title: "Step into AI & ML in Edge Computing",
      description: "Introducing Artificial Intelligence and Machine Learning in our solutions.",
      icon: <FaRobot />,
      color: "#9C27B0",
    },
  ];

  return (
    <div className="milestone-container">
      <div className="top-image">
        <img src={topImage} alt="Company History" />
      </div>

      {/* Moved Quote Section Here */}
      <div className="quote-section">
        <blockquote>
          "The only impossible journey is the one you never begin."
        </blockquote>
      </div>

      <h2>TIMELINE Infographic</h2>
      <p className="subtitle">A timeline of our milestones and achievements.</p>

      <div className="timeline-wrapper">
        <div className="timeline">
          {milestones.map((milestone, index) => (
            <div
              key={index}
              className="timeline-step"
              style={{
                marginTop: `${(milestones.length - 1 - index) * 40}px`, // Reverse the heights
                borderTop: `10px solid ${milestone.color}`,
                animationDelay: `${index * 0.3}s`, // Ascending delay: earliest first
              }}
            >
              <div className="timeline-year">{milestone.year}</div>
              <div className="timeline-content">
                <div className="timeline-icon" style={{ backgroundColor: milestone.color }}>
                  {milestone.icon}
                </div>
                <h3 className="timeline-title">{milestone.title}</h3>
                <p className="timeline-description">{milestone.description}</p>
              </div>
              {index < milestones.length - 1 && (
                <div
                  className="l-connector"
                  style={{
                    backgroundColor: milestone.color,
                    animationDelay: `${index * 0.3}s`, // Ascending delay
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Milestone;